import { render, staticRenderFns } from "./storeDetail.vue?vue&type=template&id=372e39ed"
import script from "./storeDetail.vue?vue&type=script&lang=js"
export * from "./storeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports